(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7612],{

/***/ 16371:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/split-pdf",
      function () {
        return __webpack_require__(69548);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 3224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_signature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24599);





const PdfToolsLinks = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-center text-2xl md:text-4xl text-gray-800 mb-10",
                children: "Other PDF tools offered by BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-[1280px] mx-auto flex justify-center items-center flex-wrap gap-4",
                children: _constants_signature__WEBPACK_IMPORTED_MODULE_4__/* .signatureTools.map */ .kn.map((tool, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: tool.url,
                        className: "w-[220px] h-[80px] bg-white border rounded-xl drop-shadow-md px-4 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105 z-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-full grid place-items-center text-xl text-gray-600",
                            children: tool.title
                        })
                    }, index))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PdfToolsLinks);


/***/ }),

/***/ 86318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63750);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10447);






const SignaturePopup = (param)=>{
    let { onPopupClose , source =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-gray-600/50 w-full h-full fixed z-[1000] left-0 top-0 p-4 flex justify-center items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative rounded-xl bg-violet-500 w-fit mx-auto lg:w-[700px] md:h-[500px] lg:h-[400px] text-white flex flex-col justify-between gap-[50px] md:gap-[10px] p-[50px] px-[20px] lg:px-[50px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: ()=>onPopupClose(),
                    className: "border border-b-none border-violet-300 shadow-xl absolute top-[20px] right-[20px] hover:opacity-90 cursor-pointer grid place-items-center text-white font-bold text-[20px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiOutlineClose */ .oHP, {
                        className: "font-bold"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col gap-[15px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[25px] font-semibold",
                            children: "Take Signatures inside Forms & PDFs!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-[18px]",
                            children: "Get started for Free"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "",
                            children: [
                                "Integrated Signatures: Add digital signature fields to your forms for easy signing.",
                                "PDF Downloads: Download documents with signatures as PDF files.",
                                "Super easy and simple to use."
                            ].map((item, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-[10px] text-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiFillCheckCircle */ .mny, {
                                                className: "text-[20px]"
                                            })
                                        }),
                                        item
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        target: "_blank",
                        href: "https://signature.boloforms.com/login?from=".concat(source).concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_3__/* .createUTMQueryParams */ .T0)({
                            from: source
                        })),
                        className: "flex justify-between items-center gap-4 w-fit bg-white text-violet-600 text-[17px] md:text-[20px] px-[20px] py-[8px] md:px-[40px] md:py-[12px] rounded-full hover:opacity-80",
                        children: [
                            "Check out BoloForms ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_5__/* .BsArrowRight */ .lzl, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignaturePopup);


/***/ }),

/***/ 69548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32191);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47373);
/* harmony import */ var react_pdf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59037);
/* harmony import */ var pdf_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99055);
/* harmony import */ var pdf_merger_js_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67460);
/* harmony import */ var pdf_merger_js_browser__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pdf_merger_js_browser__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8193);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89583);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56130);
/* harmony import */ var _components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86318);
/* harmony import */ var _components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3224);












react_pdf__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GlobalWorkerOptions.workerSrc */ .Z.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(react_pdf__WEBPACK_IMPORTED_MODULE_8__/* ["default"].version */ .Z.version, "/pdf.worker.js");
const BlogData = [
    {
        id: 1,
        question: "What is PDF split tool?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "A PDF split tool is a tool that allows you to split a PDF into multiple files. You can use a PDF split tool to extract pages from a PDF or save each page as a separate PDF."
            })
        })
    },
    {
        id: 2,
        question: "How to Merge PDFs Online?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "To merge PDFs online, you need to upload the PDFs you want to merge. Then, you can rearrange the order of the PDFs and download the merged PDF."
            })
        })
    },
    {
        id: 3,
        question: "How to Split a PDF into Multiple Files?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "To split a PDF into multiple files, you need to upload the PDF you want to split. Then, you can select the pages you want to split and download the split PDFs."
            })
        })
    },
    {
        id: 4,
        question: "What Other Features Do Online PDF Split Tools Offer?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "",
                children: [
                    "In addition to merging PDFs, online PDF merge tools may offer other features, such as: ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "list-disc list-inside",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Merging PDFs"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Compressing PDFs"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Converting PDFs to other formats"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Converting other formats to PDFs"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Rotating PDFs"
                            })
                        ]
                    })
                ]
            })
        })
    },
    {
        id: 5,
        question: "How many PDFs can I split?",
        answer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "",
                children: "You can split as many PDFs as you want. There is no limit on the number of PDFs you can split."
            })
        })
    }
];
const SplitPdf = ()=>{
    const [pdfFile, setPdfFile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [numberOfPages, setNumberOfPages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [mergePdf, setMergePdf] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [loader, setLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [pagesToSplit, setPagesToSplit] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        individualPages: [],
        pdfFiles: []
    });
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollToPreview = ()=>{
        const element = document.getElementById("preview-pdfs");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        setPdfFile(file);
        scrollToPreview();
    };
    const handlePdfUpload = (e)=>{
        const file = e.target.files[0];
        setPdfFile(file);
        if (file) {
            scrollToPreview();
        }
    };
    const onDocumentLoadSuccess = (param)=>{
        let { numPages  } = param;
        setNumberOfPages(numPages);
        setPagesToSplit({
            ...pagesToSplit,
            individualPages: Array.from(new Array(numPages), (el, index)=>index + 1)
        });
    // console.log(pagesToSplit)
    };
    const splitPdf = async ()=>{
        setLoader(true);
        if (!pdfFile) return;
        try {
            const pdfBytes = await pdfFile.arrayBuffer();
            const pdfDoc = await pdf_lib__WEBPACK_IMPORTED_MODULE_3__.PDFDocument.load(pdfBytes);
            const pageCount = pdfDoc.getPageCount();
            if (mergePdf) {
                await splitAndMergePdf(pdfDoc, pageCount);
            } else {
                await splitAndDownloadIndividualPdfs(pdfDoc, pageCount);
            }
        } catch (error) {
            console.error(error);
        }
    };
    const splitAndMergePdf = async (pdfDoc, pageCount)=>{
        const pdfFiles = [];
        const promises = pagesToSplit.individualPages.map(async (page)=>{
            const newPdf = await pdf_lib__WEBPACK_IMPORTED_MODULE_3__.PDFDocument.create();
            const [pdfPage] = await newPdf.copyPages(pdfDoc, [
                page - 1
            ]);
            newPdf.addPage(pdfPage);
            const pdfBytes = await newPdf.save();
            const blob = new Blob([
                pdfBytes
            ], {
                type: "application/pdf"
            });
            const file = new File([
                blob
            ], "page-".concat(page, ".pdf"), {
                type: "application/pdf"
            });
            pdfFiles.push(file);
        });
        await Promise.all(promises);
        const merger = new (pdf_merger_js_browser__WEBPACK_IMPORTED_MODULE_4___default())();
        for (const file of pdfFiles){
            await merger.add(file);
        }
        const mergedPdf = await merger.saveAsBlob();
        setLoader(false);
        downloadPdf(mergedPdf, "merged.pdf");
    };
    const splitAndDownloadIndividualPdfs = async (pdfDoc, pageCount)=>{
        pagesToSplit.individualPages.forEach(async (page)=>{
            const newPdf = await pdf_lib__WEBPACK_IMPORTED_MODULE_3__.PDFDocument.create();
            const [pdfPage] = await newPdf.copyPages(pdfDoc, [
                page - 1
            ]);
            newPdf.addPage(pdfPage);
            const pdfBytes = await newPdf.save();
            const blob = new Blob([
                pdfBytes
            ], {
                type: "application/pdf"
            });
            downloadPdf(blob, "page-".concat(page, ".pdf"));
        });
    };
    const downloadPdf = (blob, fileName)=>{
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        setLoader(false);
        setSignaturePopup(true);
    };
    const addOrRemovePage = (pageNumber)=>{
        if (pagesToSplit.individualPages.includes(pageNumber)) {
            setPagesToSplit({
                ...pagesToSplit,
                individualPages: pagesToSplit.individualPages.filter((page)=>page !== pageNumber)
            });
        } else {
            setPagesToSplit({
                ...pagesToSplit,
                individualPages: [
                    ...pagesToSplit.individualPages,
                    pageNumber
                ]
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setPagesToSplit({
            ...pagesToSplit,
            individualPages: Array.from(new Array(numberOfPages), (el, index)=>index + 1),
            pdfFiles: []
        });
    }, [
        pdfFile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mt-20 sm:mt-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Online PDF Split Tool - BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Split PDFs into multiple files. Extract pages from your PDF or save each page as a separate PDF."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "pdf split, split pdf, split pdf online, split pdf files, split pdf pages, split pdf into multiple files, split pdf into pages, split pdf into multiple files online, split pdf into pages online, split pdf into multiple files free, split pdf into pages free, split pdf into multiple files free online, split pdf into pages free online, split pdf into multiple files free download, split pdf into pages free download, split pdf into multiple files free software, split pdf into pages free software, split pdf into multiple files free download software, split pdf into pages free download software, split pdf into multiple files free download online, split pdf into pages free download online, split pdf into multiple files free download for windows 10, split pdf into pages free download for windows 10, split pdf into multiple files free download for windows 7, split pdf into pages free download for windows 7"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/split-pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Online PDF Split Tool - BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Split PDFs into multiple files. Extract pages from your PDF or save each page as a separate PDF."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/pdf-tools/split-pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en_US"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Online PDF Split Tool - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Split PDFs into multiple files. Extract pages from your PDF or save each page as a separate PDF."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-[1280px] mx-auto px-2 md:px-10 py-20 rounded-xl relative flex flex-col gap-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-violet-500 text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "text-3xl md:text-6xl text-gray-800",
                                        children: "Online PDF Split Tool"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-lg md:text-2xl mt-4 text-gray-600",
                                        children: "Split PDFs into multiple files. Extract pages from your PDF or save each page as a separate PDF."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "extraOutline p-4 bg-white bg-whtie mx-auto rounded-lg w-full md:w-[600px]",
                                onDragEnter: (e)=>e.preventDefault(),
                                onDragOver: (e)=>e.preventDefault(),
                                onDragLeave: (e)=>e.preventDefault(),
                                onDrop: handleDrop,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "file_upload px-2 md:px-20 py-5 md:py-14 relative border-4 border-dotted border-gray-300 rounded-lg",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_9__/* .FaFileUpload */ .Gq2, {
                                            className: "text-gray-400 w-20 md:w-32 mx-auto mb-6 md:mb-10 text-[80px] md:text-[120px]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "input_field flex flex-col w-full mx-auto text-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            onChange: handlePdfUpload,
                                                            className: "text-sm cursor-pointer w-36 hidden",
                                                            type: "file",
                                                            accept: ".pdf"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text bg-violet-600 text-white text-xl border border-gray-300 rounded-xl font-semibold cursor-pointer py-3 md:py-4 hover:bg-indigo-500",
                                                            children: "Upload PDF File"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "title text-gray-500 uppercase text-lg md:text-xl",
                                                    children: "or drop file here"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "preview-pdfs",
                        className: "max-w-[1280px] mx-auto flex flex-col gap-14 justify-center items-center",
                        children: [
                            pdfFile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        className: "text-3xl font-light text-center text-gray-700",
                                        children: [
                                            "Disselect Pages that you ",
                                            "don't",
                                            " want"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full flex flex-wrap justify-center gap-10 md:border-2 md:px-10 md:py-14 md:rounded-xl",
                                        children: Array.from(new Array(numberOfPages), (el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "border drop-shadow-2xl w-fit relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        file: pdfFile,
                                                        onLoadSuccess: onDocumentLoadSuccess,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_pdf__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            pageNumber: index + 1,
                                                            width: 260,
                                                            renderTextLayer: false,
                                                            renderAnnotationLayer: false
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute top-2 left-2 w-8 h-8 bg-violet-500 rounded-full text-xl text-white flex justify-center items-center cursor-pointer",
                                                        children: index + 1
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        onClick: ()=>addOrRemovePage(index + 1),
                                                        className: "absolute top-2 right-2 w-8 h-8 ".concat(pagesToSplit.individualPages.includes(index + 1) ? "bg-violet-500" : "bg-gray-400", " rounded-full text-xl text-white flex justify-center items-center cursor-pointer"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_12__/* .AiOutlineCheck */ .bzc, {})
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            }),
                            pdfFile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                id: "split-pdfs",
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex justify-center items-center gap-2 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                onChange: (e)=>setMergePdf(e.target.checked),
                                                className: "w-5 h-5",
                                                type: "checkbox",
                                                name: "",
                                                id: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                htmlFor: "",
                                                className: "text-gray-600 text-xl",
                                                children: "Merge Selected PDFs into a single PDF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: splitPdf,
                                        className: "bg-violet-600 mx-auto w-full sm:w-[350px] py-4 text-xl rounded-lg font-semibold text-white flex items-center justify-center gap-4 hover:bg-violet-400",
                                        children: loader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "flex items-center text-white space-x-2 ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_13___default().loader)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "",
                                                    children: "Downloading"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    class: "w-2 h-2 bg-white rounded-full animate-bounce"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Confirm to Split ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_12__/* .AiOutlineSplitCells */ .oor, {
                                                    className: "text-3xl"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    signaturePopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignaturePopup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        onPopupClose: ()=>setSignaturePopup(false),
                        source: "SPLIT_PDF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfToolsLinks__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CalculatorBlogs_Blog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                heading: "PDF Split Tool FAQs",
                                BlogData: BlogData
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SplitPdf);


/***/ }),

/***/ 10411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signatureFont":"signature_signatureFont__RxQpu","signatureShadow":"signature_signatureShadow__hfutn","headingAnimation":"signature_headingAnimation___OGQQ","changeImageAnimation":"signature_changeImageAnimation__xeM9_","moveLineAnimation":"signature_moveLineAnimation__uc0qS","changeHeightAnimation":"signature_changeHeightAnimation__AjMNd","rotateIconsAnimation":"signature_rotateIconsAnimation__pFB1R","moveStepsLineAnimation":"signature_moveStepsLineAnimation__MUlje","moveTextUpAnimation":"signature_moveTextUpAnimation__Y6QVi","scrollImageAnimation":"signature_scrollImageAnimation___7bVj","scrollImageAnimationMobile":"signature_scrollImageAnimationMobile__pGKm5","stepsImage":"signature_stepsImage__zJWMg","countryImage":"signature_countryImage__wMRyn","imagePosition":"signature_imagePosition__iJEJi","legalImages":"signature_legalImages__3yVVS","loader":"signature_loader__Zqlyl","topBg":"signature_topBg__j0SDC"};

/***/ }),

/***/ 67460:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { PDFDocument } = __webpack_require__(99055)

class PDFMerger {
  constructor () {
    this.reset()
  }

  reset () {
    this.doc = undefined
  }

  async add (inputFile, pages) {
    await this._ensureDoc()
    if (typeof pages === 'undefined' || pages === null) {
      await this._addEntireDocument(inputFile)
    } else if (Array.isArray(pages)) {
      await this._addGivenPages(inputFile, pages)
    } else if (pages.indexOf(',') > 0) {
      const aPages = pages.replace(/ /g, '').split(',')
      await this._addGivenPages(inputFile, aPages)
    } else if (pages.toLowerCase().indexOf('to') >= 0) {
      const span = pages.replace(/ /g, '').split('to')
      const from = parseInt(span[0])
      const to = parseInt(span[1])
      await this._addFromToPage(inputFile, from, to)
    } else if (pages.indexOf('-') >= 0) {
      const span = pages.replace(/ /g, '').split('-')
      const from = parseInt(span[0])
      const to = parseInt(span[1])
      await this._addFromToPage(inputFile, from, to)
    } else {
      throw new Error('invalid parameter "pages"')
    }
  }

  async _ensureDoc () {
    if (!this.doc) {
      this.doc = await PDFDocument.create()
    }
  }

  async _getInputAsUint8Array (input) {
    if (input instanceof Uint8Array) {
      return input
    }

    if (input instanceof ArrayBuffer || Object.prototype.toString.call(input) === '[object ArrayBuffer]') {
      return new Uint8Array(input)
    }

    if (typeof input === 'string' || input instanceof String) {
      try {
        Boolean(new URL(input))
      } catch (e) {
        throw new Error(`This is not a valid url: ${input}`)
      }
      const res = await window.fetch(input)
      const aBuffer = await res.arrayBuffer()
      return new Uint8Array(aBuffer)
    }

    if (input instanceof window.File) {
      const fileReader = new window.FileReader()
      fileReader.onload = function (evt) {
        return fileReader.result
      }
      fileReader.readAsArrayBuffer(input)
    }

    if (input instanceof window.Blob) {
      const aBuffer = await input.arrayBuffer()
      return new Uint8Array(aBuffer)
    }

    console.log({ input, inputc: Object.prototype.toString.call(input), ArrayBuffer, eq: input.contructor !== ArrayBuffer })
    throw new Error('pdf must be represented as an ArrayBuffer, Blob, File, URL or fetchable string')
  }

  async _addEntireDocument (input) {
    const src = await this._getInputAsUint8Array(input)
    const srcDoc = await PDFDocument.load(src)

    const copiedPages = await this.doc.copyPages(srcDoc, srcDoc.getPageIndices())
    copiedPages.forEach((page) => {
      this.doc.addPage(page)
    })
  }

  async _addFromToPage (inputFile, from, to) {
    if (typeof from !== 'number' || typeof to !== 'number' || from < 0 || from < 0) {
      throw new Error('Invalid function parameter. \'from\' and \'to\' must be positive \'numbers\'.')
    }
    if (to < from) {
      throw new Error('Invalid function parameter. \'to\' must be greater or eaqual to \'from\'.')
    }

    const src = await this._getInputAsUint8Array(inputFile)
    const srcDoc = await PDFDocument.load(src)
    const pageCount = srcDoc.getPageCount()

    if (from >= pageCount || to >= pageCount) {
      throw new Error(`Invalid function parameter. The document has not enough pages. (from:${from}, to:${to}, pages:${pageCount})`)
    }

    // create a array [2,3,4] with from=2 and to=4
    const pages = Array.from({ length: (to - from) + 1 }, (_, i) => i + from - 1)
    const copiedPages = await this.doc.copyPages(srcDoc, pages)
    copiedPages.forEach((page) => {
      this.doc.addPage(page)
    })
  }

  async _addGivenPages (inputFile, pages) {
    if (pages.length <= 0) return

    const src = await this._getInputAsUint8Array(inputFile)
    const srcDoc = await PDFDocument.load(src)

    const pagesIndexed1 = pages.map(p => p - 1)
    const copiedPages = await this.doc.copyPages(srcDoc, pagesIndexed1)
    copiedPages.forEach((page) => {
      this.doc.addPage(page)
    })
  }

  async setMetadata (metadata) {
    await this._ensureDoc()
    if (metadata.producer) this.doc.setProducer(metadata.producer)
    if (metadata.author) this.doc.setAuthor(metadata.author)
    if (metadata.title) this.doc.setTitle(metadata.title)
    if (metadata.creator) this.doc.setCreator(metadata.creator)
  }

  async saveAsBuffer () {
    await this._ensureDoc()
    return await this.doc.save()
  }

  async saveAsBlob () {
    const buffer = await this.saveAsBuffer()

    return new window.Blob([buffer], {
      type: 'application/pdf'
    })
  }

  async save (fileName) {
    const dataUri = await this.doc.saveAsBase64({ dataUri: true })

    const link = document.createElement('a')
    link.href = dataUri
    link.download = `${fileName}.pdf`
    link.click()
  }
}

module.exports = PDFMerger


/***/ }),

/***/ 69349:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 49080:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57588:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 3071:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 15232:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,3701,1717,9846,9055,4599,9774,2888,179], function() { return __webpack_exec__(16371); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);